export default {"src":"/_next/static/media/info.9f4b5657.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};